export default __webpack_public_path__ + "static/media/LOGO_contruyendo_banner_bco.830e4575.png";